import styled, { css } from 'styled-components';

import { flexCenter, flexSpaceBetween } from '../../style/reusableStyle';

export const ProgressStepWrapperStyled = styled.div`
  height: 70px;
  max-width: 800px;
  ${flexSpaceBetween(0)};
  gap: 0px;
`;

export const IndividualStepStyled = styled.div<{
  $stepType: 'completed' | 'in-progress' | 'pending';
}>`
  flex: 1;
  height: 100%;
  ${flexCenter(0)};
  position: relative;
  &::before {
    content: '';
    position: absolute;
    background: ${({ theme }) => theme.colors.disableButtonText};
    left: 0px;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);

    height: 2px;
  }
  &::after {
    content: '';
    position: absolute;
    background: ${({ theme }) => theme.colors.disableButtonText};
    left: 50%;
    transform: translateX(-50%);
    top: 50%;
    transform: translateY(-50%);
    height: 13px;
    width: 13px;
    border-radius: 50%;
  }

  ${({ $stepType }) =>
    $stepType === 'completed' &&
    css`
      &::after {
        background: ${({ theme }) => theme.colors.green.strong};
        box-shadow:
          0px 0px 0px 4px #81e3c0,
          0px 0px 0px 8px #c4f2e2;
      }
    `}

  ${({ $stepType }) =>
    $stepType === 'in-progress' &&
    css`
      &::after {
        background: ${({ theme }) => theme.colors.green.strong};
        box-shadow:
          0px 0px 0px 4px ${({ theme }) => theme.colors.disableText},
          0px 0px 0px 8px ${({ theme }) => theme.colors.disable};
      }
    `}
 & .step-label {
    max-width: 100%;
    position: absolute;
    top: calc(50% + 27px);
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    & .step-label {
      font-size: 10px;
    }
    &:nth-child(2n) {
      & .step-label {
        top: calc(50% - 27px);
      }
    }
  }
`;
